import type { Alpha2CountryCode } from '@/lib/types/alpha2CountryCode'
import type { SendRequestType } from '@/lib/utils/shared/httpTools'
import httpTools from '@/lib/utils/shared/httpTools'

export type HydraValidateAddressProps = {
  address1: string
  address2: string
  state: string
  zip?: string
  city: string
  country: Alpha2CountryCode
}

export type HydraValidateAddressResponse = {
  items: {
    city: string
    state: string
    address1: string
    address2: string
    zip4: string
    zip5: string
    unique: boolean
    returnText: string
  }[]
}

export const HydraValidateShippingAddress = ({
  address1,
  address2,
  state,
  zip,
  city,
  country,
}: HydraValidateAddressProps) => {
  const request: SendRequestType = {
    method: 'GET',
    url: `/addresses?country=${country}&address1=${address1}&address2=${address2}&state=${state}&zip=${zip}&city=${city}`,
    withAuth: false,
  }

  return httpTools.sendRequest<HydraValidateAddressResponse>(request)
}
